<div class="chat-accessing-dialog">
  <div>{{ 'components.chatAccessingDialog.labels.text' | translate }}</div>

  <div class="chat-accessing-dialog__buttons">
    <button tuiButton type="button" [size]="tuiElementMediumSize" (click)="close()">
      {{ 'common.buttons.close' | translate }}
    </button>
  </div>
</div>
